// Taken from https://github.com/HenrikJoreteg/milliseconds
// MIT license

const calc = (m: number) => (n: number) => Math.round(n * m)

const MS_MULTIPLIER = 1e3

export const SECONDS = {
  years: 315576e2,
  months: 26298e2,
  weeks: 6048e2,
  days: 864e2,
  hours: 36e2,
  minutes: 60,
  seconds: 1
} as const

export const MS = {
  years: SECONDS.years * MS_MULTIPLIER,
  months: SECONDS.months * MS_MULTIPLIER,
  weeks: SECONDS.weeks * MS_MULTIPLIER,
  days: SECONDS.days * MS_MULTIPLIER,
  hours: SECONDS.hours * MS_MULTIPLIER,
  minutes: SECONDS.minutes * MS_MULTIPLIER,
  seconds: SECONDS.seconds * MS_MULTIPLIER
} as const

export const ms = {
  years: calc(MS.years),
  months: calc(MS.months),
  weeks: calc(MS.weeks),
  days: calc(MS.days),
  hours: calc(MS.hours),
  minutes: calc(MS.minutes),
  seconds: calc(MS.seconds)
} as const
